<template>
  <n-checkbox ref="checkboxRef" v-model:checked="checked" class="nd-checkbox" v-bind="$attrs">
    <slot></slot>
  </n-checkbox>
</template>

<script lang="ts" setup>
import { NCheckbox } from 'naive-ui'

const checkboxRef = ref<Nullable<typeof NCheckbox>>(null)
const checked = defineModel<boolean>('checked', { default: false })

const focus = () => checkboxRef.value?.focus?.()
const blur = () => checkboxRef.value?.blur?.()

defineExpose({
  focus,
  blur,
})
</script>
